export enum UserRole {
  None = 0,
  Admin = 1,
  User = 2,
  Extern = 3,
  Streetworker = 4,
  AdminReadOnly = 5,
  TrackerRegistor = 6,
}

export interface AuthenticateRequest {
  email: string;
  password: string;
}

export interface AuthenticateResponse {
  id: number;
  title: string;
  firstName: string;
  lastName: string;
  email: string;
  role: UserRole;
  created: string;
  updated: string | null;
  isVerified: boolean;
  jwtToken: string;
}
